export default __webpack_public_path__ + "637e1b8a0e0275ffddfa0c1b76765611.svg";